import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { content } from "./content";

const LangCtx = createContext(null);

const readStored = () => {
  try {
    const v = localStorage.getItem("noorin-lang");
    return v === "en" || v === "fa" ? v : "fa";
  } catch {
    return "fa";
  }
};

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(readStored);
  const t = content[lang];

  useEffect(() => {
    const el = document.documentElement;
    el.lang = lang;
    el.dir = t.dir;
    document.title = t.meta.title;
    document.querySelector('meta[name="description"]')?.setAttribute("content", t.meta.description);
    try {
      localStorage.setItem("noorin-lang", lang);
    } catch {
      /* storage unavailable */
    }
    window.dispatchEvent(new Event("noorin-lang"));
  }, [lang, t]);

  useEffect(() => {
    const sync = () => {
      try {
        const value = localStorage.getItem("noorin-lang");
        if (value === "en" || value === "fa") setLang((current) => (current === value ? current : value));
      } catch {
        /* storage unavailable */
      }
    };
    window.addEventListener("noorin-lang", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("noorin-lang", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const value = useMemo(() => ({ lang, t, setLang, dir: t.dir, isFa: lang === "fa" }), [lang, t]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
